export default "__VITE_ASSET__DxOLcCjV__"